export default "__VITE_ASSET__qC_iD8EC__"